import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './custom.css';
import './App.css';

// Render the App component directly, without StrictMode or any wrappers.
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);